import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCheckC({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.293 15.707l-3-3a1 1 0 111.414-1.414l1.94 1.94a.5.5 0 00.707 0l4.939-4.94a1 1 0 011.414 1.414l-6 6a.997.997 0 01-1.414 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCheckC
